const lettersOnly = value => Array.from(String(value || '').normalize('NFKC'))
  .filter(character => /\p{L}/u.test(character));

export const learnerGradeToken = value => {
  const normalized = String(value || '').trim().toUpperCase();
  const numeric = normalized.match(/(?:^|\D)(1[0-2]|[1-9])(?:\D|$)/);
  if (numeric) return numeric[1];
  if (/PRE\s*-?\s*K|PREK|PK/.test(normalized)) return 'PK';
  if (/KINDER|^K$/.test(normalized)) return 'K';
  return '';
};

export const learnerAccessSuffix = value => String(value || '').trim().match(/(\d{3})$/)?.[1] || '';

export const LEARNER_REFERENCE_LABEL_VERSION = 'learner-reference-label-1.0.0';

export const learnerReferenceLabel = (record = {}) => {
  const suffix = learnerAccessSuffix(record.accessCode ?? record.access_code ?? '');
  if (suffix) return `Learner-${suffix}`;
  const rawId = record.learnerAccountId ?? record.learner_account_id ?? record.id;
  const id = Number(rawId);
  return Number.isSafeInteger(id) && id > 0
    ? `Learner-${String(id).padStart(3, '0')}`
    : 'Learner';
};

export const learnerDisplayLabel = (record = {}) => {
  const role = String(record.role || '').toLowerCase();
  const isLearner = role === 'subuser'
    || record.parentUserId != null || record.parent_user_id != null
    || record.learnerAccountId != null || record.learner_account_id != null;
  if (!isLearner) return String(record.name || record.label || 'Account').trim();
  return String(record.learnerLabel || record.referenceLabel || learnerReferenceLabel(record)).trim();
};

export const isLearnerAlias = value => /^\p{L}\*{3}(?:PK|K|1[0-2]|[1-9])\d{3}\p{L}$/u
  .test(String(value || '').trim());

export function deriveLearnerAlias(name, gradeLevel, accessCode) {
  if (isLearnerAlias(name)) return String(name).trim();
  const firstName = String(name || '').trim().split(/\s+/u)[0];
  const letters = lettersOnly(firstName);
  const grade = learnerGradeToken(gradeLevel);
  const suffix = learnerAccessSuffix(accessCode);
  if (!letters.length || !grade || !suffix) return '';
  return `${letters[0].toUpperCase()}***${grade}${suffix}${letters.at(-1).toLowerCase()}`;
}


export function learnerAccountKey(record = {}) {
  const id = record.learner_account_id ?? record.learnerAccountId;
  if (/^[1-9]\d*$/.test(String(id ?? '')) && Number.isSafeInteger(Number(id))) return `learner-account:${id}`;
  return JSON.stringify([String(record.code_used || record.codeUsed || record.accessCode || ''),
    String(record.student_name || record.studentName || record.learnerAlias || '').trim() || `unknown-attempt:${record.id}`]);
}
